import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/microsoft': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 32h214.6v214.6h-214.6v-214.6zM233.4 32h214.6v214.6h-214.6v-214.6zM0 265.4h214.6v214.6h-214.6v-214.6zM233.4 265.4h214.6v214.6h-214.6v-214.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/microsoft.js
// module id = 933
// module chunks = 0